import { Fonts, Metrics } from "Themes";

import { MainContainerTheme } from "Themes/Metrics";
import { mobileSize } from "Themes/Metrics";
import styled from "styled-components";

export const MainContainer = styled(MainContainerTheme)`
  padding-top: 50px;
  width: 60%;
  @media ${mobileSize.large} {
    width: 100%;
    padding-top: 50px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "row"};
  `;

export const TopContainer = styled.div`
  border-bottom: solid 2px lightgray;
  padding-bottom: 20px;
`;

export const LinkContainer = styled.div`
  display: flex;
  padding: 10px 0px;
  @media ${mobileSize.large} {
    justify-content: center;
  }
`;

export const MembersContainer = styled.div`
  width: 100%;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 5%;
  cursor: pointer;
`;

export const MemberIcon = styled.div`
  border: solid 2px lightgray;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
`;

export const JoinConfirmation = styled.div`
  border: solid 2px green;
  border-radius: 5px;
  padding: 20px;
`;

export const ProjectImageContainer = styled.div`
  width: 100px;
  border: solid 2px lightgray;
  border-radius: ${Metrics.borderRadius.medium};
  margin-right: 10px;
`;

export const ProjectImage = styled.div`
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentOptionsContainer = styled.div`
  display: flex;
`;

export const ContentText = styled.p`
  cursor: pointer;
  margin-right: 10px;
  &:hover {
    text-decoration: underline;
  }
  font-family: ${Fonts.primaryFontFamily}
  font-weight: ${(props) => (props.selected ? "bold" : null)};
`;

export const ContentContainer = styled.div`
  flex-wrap: wrap;
  overflow-y: auto;
  display: flex;
  width: 100%;
`;

export const CommentsContainer = styled.div`
  padding: 20px 20%;
  margin-top: 10px;
  @media ${mobileSize.large} {
    padding: 10px;
  }
`;

export const ProjectCommentsContainer = styled.div`
  margin-top: 50px;
  padding-top: 20px;
  border-top: solid 2px lightgray;
`;

export const Comment = styled.div`
  border: solid 2px lightgray;
  border-radius: 5px;
  padding: 20px;
`;

export const ProjectUpdateContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ProjectUpdateText = styled.div`
  border: solid 2px lightgray;
  border-radius: 5px;
  padding: 10px;
  width: 30%;
  text-align: center;
  margin-bottom: 10px;
`;

export const ProjectNameContainer = styled.div`
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.size.large}px;
  display: flex;
  flex-direction: column;
`;

export const NoContentFound = styled.div`
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.size.medium}px;
`;

export const ProjectDetailContainer = styled.div`
  font-size: ${Fonts.size.small}px;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;

export const LinksContainer = styled.div`
  padding: 10px;
  flex: 1;
  display: flex;
`;

export const CommentContainer = styled.div`
  flex: 1;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
`;

export const UpdateContainer = styled.div`
  flex: 1;
  border: solid 2px ligthgray;
  border-radius: 5px;
  padding: 40px 20px;
  margin-right: 2.5%;
`;

export const MediaContainer = styled.div`
  border: solid 2px lightgray;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  margin-left: 2.5%;
`;
